var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E6E9"
    },
    d: "M337.335,0H95.219C84.874,0,76.488,8.386,76.488,18.732v430.829c0,10.345,8.386,18.732,18.732,18.732 H401.17c10.345,0,18.732-8.386,18.732-18.732V82.567L337.335,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.39,
    y: 258.067,
    style: {
      fill: "#27A2DB"
    },
    width: 371.512,
    height: 128.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M182.722,293.744c7.567,6.85,11.342,16.377,11.342,28.583c0,12.201-3.665,21.861-11.004,28.971 c-7.339,7.115-18.571,10.67-33.687,10.67h-26.056v-78.501h26.952C164.343,283.467,175.164,286.894,182.722,293.744z  M180.702,322.66c0-17.968-10.291-26.952-30.881-26.952h-13.252v53.793h14.714c9.505,0,16.789-2.262,21.843-6.795 C178.179,338.179,180.702,331.498,180.702,322.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M276.828,351.129c-7.933,7.75-17.739,11.625-29.419,11.625s-21.486-3.875-29.419-11.625 c-7.942-7.745-11.908-17.406-11.908-28.971c0-11.57,3.966-21.226,11.908-28.976c7.933-7.75,17.739-11.62,29.419-11.62 s21.486,3.87,29.419,11.62c7.942,7.75,11.908,17.406,11.908,28.976C288.736,333.723,284.77,343.383,276.828,351.129z  M267.122,301.997c-5.356-5.538-11.927-8.307-19.713-8.307c-7.787,0-14.358,2.769-19.713,8.307 c-5.346,5.543-8.024,12.26-8.024,20.161s2.678,14.618,8.024,20.156c5.356,5.543,11.927,8.312,19.713,8.312 c7.787,0,14.358-2.769,19.713-8.312c5.346-5.538,8.024-12.256,8.024-20.156S272.469,307.539,267.122,301.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M341.296,349.95c4.56,0,8.49-0.763,11.79-2.298c3.29-1.535,6.736-3.989,10.336-7.357l8.527,8.76 c-8.308,9.208-18.397,13.814-30.26,13.814c-11.872,0-21.715-3.82-29.538-11.456c-7.823-7.636-11.735-17.296-11.735-28.976 s3.985-21.409,11.963-29.2c7.969-7.782,18.041-11.675,30.205-11.675s22.327,4.492,30.488,13.476l-8.417,9.208 c-3.747-3.592-7.284-6.1-10.62-7.526c-3.327-1.421-7.238-2.134-11.735-2.134c-7.933,0-14.595,2.568-19.987,7.695 c-5.392,5.127-8.088,11.68-8.088,19.654c0,7.974,2.678,14.636,8.033,19.987C327.615,347.277,333.957,349.95,341.296,349.95z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2D93BA"
    },
    points: "48.39,386.364 76.488,412.491 76.488,386.364 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "337.336,82.567 419.902,82.567 337.335,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5D6DB"
    },
    points: "353.221,82.567 419.902,121.255 419.902,82.567 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/Doc.471295a083d75b3f5366b1446e76f2d1.svg";
export { ForwardRef as ReactComponent };